import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CancelIcon from "@mui/icons-material/Cancel";
import "./othersmodule.css";
// import hljs from 'highlight.js';
// import 'highlight.js/styles/default.css';
import XmlViewer from "react-xml-viewer";

const InnerDialog = ({
  selectedRow,
  information,
  editedOriginalMessage,
  handleOriginalMessageChange,
  handleCopyClick,
}) => {
  const [openPreview, setOpenPreview] = useState(false);

  const handlePreviewOpen = () => {
    setOpenPreview(true);
  };

  const handlePreviewClose = () => {
    setOpenPreview(false);
  };
  // useEffect(() => {
  //   hljs.highlightAll();
  // }, [openPreview]);
  // Function to add line numbers to content

  // Determine the XML content to display
  const xmlContent =
    editedOriginalMessage !== "" ? editedOriginalMessage : information?.message;
  // const addLineNumbers = (content) => {
  //   const lines = content.split('\n');
  //   return lines.map((line, index) => `${index + 1}: ${line}`).join('\n');
  // };

  const displayXmlWithLineNumbers = (xmlContent) => {
    if (!xmlContent) return null; // Return early if xmlContent is null or undefined

    const lines = xmlContent.split("\n");
    let lineNumber = 1;

    const numberedLines = lines.map((line, index) => {
      if (line.trim() !== "") {
        return (
          <div key={`line-${index}`}>
            <span
              style={{ fontWeight: "bold", marginRight: "8px", color: "black" }}
            >
              {lineNumber++}:
            </span>{" "}
            {line}
          </div>
        );
      } else {
        return (
          <div key={`line-${index}`}>
            {/* Render a non-breaking space for empty lines */}
            &nbsp;
          </div>
        );
      }
    });

    return numberedLines;
  };
  // const addLineNumbers = (content) => {
  //   // Split content into lines
  //   const lines = content.split("\n");

  //   // Initialize result string
  //   let numberedContent = "";

  //   // Track line number
  //   let lineNumber = 1;

  //   // Iterate through lines
  //   lines.forEach((line) => {
  //     // Trim leading and trailing spaces from each line
  //     const trimmedLine = line.trim();

  //     // Only increment line number if trimmed line is not empty
  //     if (trimmedLine !== "") {
  //       numberedContent += `${lineNumber}: ${trimmedLine}\n`;
  //       lineNumber++;
  //     } else {
  //       // Handle empty lines or lines with only spaces by adding them without incrementing lineNumber
  //       numberedContent += `${lineNumber}: \n`;
  //     }
  //   });

  //   return numberedContent;
  // };

  // Preprocess XML content with line numbers
  // const xmlWithLineNumbers = addLineNumbers(xmlContent);

  //  const addLineNumbers = (content) => {
  //   const lines = content.split('\n');
  //   let lineNumber = 1;
  //   return lines.map((line) => {
  //     const trimmedLine = line.trim(); // Trim leading and trailing spaces
  //     if (trimmedLine !== "") {
  //       const numberedLine = `${lineNumber}: ${trimmedLine}`;
  //       lineNumber++;
  //       return numberedLine;
  //     }
  //     return "";
  //   }).join('\n');
  // };

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          backgroundColor: "var(--color-dialogcolor)",
          padding: "2.4rem 1.5rem 0 1.5rem",
          height: "14rem",
        }}
      >
        <div style={{ width: "33.33%" }}>
          <p className="customTextfont Textpadding">Message ID</p>
          <p className="customText">{selectedRow?.message_Id ?? "N/A"}</p>
          <p className="customTextfont Textpadding">Message Type Name</p>
          <p className="customText">
            {selectedRow?.message_type_name ?? "N/A"}
          </p>
        </div>
        <div style={{ width: "33.33%" }}>
          <p className="customTextfont Textpadding">Message Status Name</p>
          <p className="customText">
            {selectedRow?.message_status_name ?? "N/A"}
          </p>
          <p className="customTextfont Textpadding">Source</p>
          <p className="customText">{selectedRow?.source ?? "N/A"}</p>
        </div>
        <div style={{ width: "33.33%" }}>
          <p className="customTextfont Textpadding">Destination</p>
          <p className="customText">{selectedRow?.Dest ?? "N/A"}</p>
          <p className="customTextfont Textpadding">Original Message ID</p>
          <p className="customText">
            {selectedRow?.original_message_identifier ?? "N/A"}
          </p>
        </div>
      </div>
      {/* //////Bottom/ */}
      <Grid
        container
        spacing={1}
        sx={{ padding: "1rem" }}
        justifyContent="center"
      >
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p
              className="customTextfont Textpadding"
              style={{ fontWeight: "bold", margin: 0 }}
            >
              Original Message
            </p>
            <IconButton
              onClick={handlePreviewOpen}
              style={{ marginLeft: "auto" }}
            >
              <FullscreenIcon />
            </IconButton>
          </div>
          <textarea
            className="mt-2 customTextarea"
            style={{
              height: "12rem",
              width: "100%",
              border: "2px solid var(--color-primary-lighterMax)",
              overflow: "auto",
              padding: "8px",
            }}
            value={xmlContent}
            onChange={handleOriginalMessageChange}
          />
          <Dialog
            open={openPreview}
            onClose={handlePreviewClose}
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle>
              <IconButton
                onClick={handlePreviewClose}
                sx={{ position: "absolute", right: 0, top: 0 }}
              >
                <CancelIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  fontFamily: "monospace",
                  lineHeight: "1.4",
                }}
              >
                {displayXmlWithLineNumbers(xmlContent)}
              </pre>
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
    </>
  );
};
export default InnerDialog;
